module.exports = "/_next/static/images/langoustines-0e40aa5eee082f527ce012a4d2f73996.png";